import React from "react";
import { useAppSelector } from "../hooks";
import { BtnWrapper } from "../styles/Docs/DocsToolbar.styled";
import { RefreshIcon } from "../../public/icons";
import Tooltip from "@mui/material/Tooltip";

export default function RefreshButton(props: RefreshButtonProps) {
  const docs = useAppSelector((state) => state.docs);

  return (
      <Tooltip 
            title="Оновити"
      >
        <span>
        <BtnWrapper
            onClick={props.docsUpdate}
            disabled={docs.state === "loading"}
            $bgColor="var(--sidebar-hover)"
        >
          <RefreshIcon 
            color={docs.state === "loading" ? "var(--background)":"var(--blue)"}
          />
        </BtnWrapper>
        </span>
      </Tooltip>
)}